module.exports = __webpack_public_path__ + "static/media/anwar_hendarto.d0fde203.jpg";